import { render } from "./colorpickermenu.vue?vue&type=template&id=289ae9f6"
import script from "./colorpickermenu.vue?vue&type=script&lang=js"
export * from "./colorpickermenu.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__